import { Marker, MarkerProps } from "react-leaflet";

interface MarkerWithIndexProps extends MarkerProps {
  markerIndex: number;
}

export const MarkerWithIndex = (props: MarkerWithIndexProps) => (
  <Marker {...props} />
);
